module.exports = __webpack_public_path__ + "img/log_keyboard1.27361118.png";